import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LoggerService } from 'src/app/services/Non-Master/logger.service';
import { tBillPayModel } from 'src/app/models/tBillPayModel';
import { tBillPayService } from 'src/app/services/tBillPay.service';

@Component({
  selector: 'app-bill-payment-prepay-dialog',
  templateUrl: './bill-payment-prepay-dialog.component.html',
  styleUrls: ['./bill-payment-prepay-dialog.component.css']
})
export class BillPaymentPrepayDialogComponent implements OnInit {

  TAG = "BillPaymentPrepayDialogComponent";

  @Input() selectedBillPayModel: tBillPayModel;

  editForm: FormGroup;
  submitted = false;


  constructor(
    private formBuilder: FormBuilder,
    public activeModal: NgbActiveModal,
    private log: LoggerService,
    private tBillPayService : tBillPayService,

  ) { }

  ngOnInit() {
    this.editForm = this.formBuilder.group({
      prepayValue: ['', [Validators.required]],
    });
  }

  cancel() {
    this.log.i(this.TAG, "do cancel");
    this.activeModal.close('Close click');
  }

  get f() { return this.editForm.controls; }

  confirm() {
    // this.activeModal.dismiss();
    var prepayValue = this.editForm.get('prepayValue').value;
    this.log.i(this.TAG, "do confirm value ="+prepayValue);
    this.submitted = true;

    if (this.editForm.valid) {

      this.selectedBillPayModel.bpFinalPrice = prepayValue;
      this.selectedBillPayModel.bpLineAmount = prepayValue;
      this.selectedBillPayModel.bpArAmount = prepayValue;

      this.log.i(this.TAG,"value = "+JSON.stringify(this.selectedBillPayModel));
      this.tBillPayService.updateData(this.selectedBillPayModel).subscribe(data => {

        this.log.i(this.TAG,"value = "+JSON.stringify(data));
        this.activeModal.close(data);

      });

    }

  }


}
